import importscript from "../../../../swgfl/javascript/import-script.js";

export default (img, config) => {
	return new Promise((resolve, reject) => {
		importscript(config.base + "javascript/build/photodna.js", () => {
			PhotoDnaChrysalisHash(img)
				.then(hash => resolve(hash))
				.catch(error => reject(error));
		}, {}, reject); // reject if the script cannot be loaded, otherwise hashing hangs forever
	});

	// return new Promise((resolve, reject) => {
	// 	const worker = new Worker(config.base + "javascript/build/photodna.js");
	// 	worker.onmessage = e => {
	// 		if (typeof e.data === "string") {
	// 			reject(e.data);
	// 		} else {
	// 			// console.log(e);
	// 			resolve(e.data);
	// 		}
	// 	}

	// 	const params = {
	// 		width: img.width,
	// 		height: img.height,
	// 		form: "RGBA",
	// 		id: count++,
	// 		binary: config.base + "javascript/hash/photodna.wasm"
	// 	};

	// 	worker.postMessage({data: img.getContext("2d").getImageData(0, 0, img.width, img.height), params});
	// });
};